import React from "react";
import "./Reels_ServiceSection.css";
import { FaVideo, FaHeart, FaListUl, FaHashtag, FaMusic, FaShieldAlt, FaMagic, FaShareSquare, FaChartLine } from 'react-icons/fa';

// import Lock_Unlock from "./src/img/dshield";


const services = [
  {
    icon: FaVideo,
    imgAlt: "Seamless Video Creation",
    title: "Seamless Video Creation",
    description: "Record, edit, and share short videos easily with tools for all content creators."
  },
  {
    icon: FaHeart,
    imgAlt: "Interactive User Engagement",
    title: "Interactive User Engagement",
    description: "Engage with likes, shares, and comments, connecting creators with their audience."
  },
  {
    icon: FaListUl,
    imgAlt: "Personalized Content Feed",
    title: "Personalized Content Feed",
    description: "Enjoy curated video feeds that match your interests using smart algorithms."
  },
  {
    icon: FaHashtag,
    imgAlt: "Trending Hashtags & Challenges",
    title: "Trending Hashtags & Challenges",
    description: "Join viral trends and increase your visibility in the online community."
  },
  {
    icon: FaMusic,
    imgAlt: "In-App Music Library",
    title: "In-App Music Library",
    description: "Add trending audio and music to make videos fun, dynamic, and creative."
  },
  {
    icon: FaShieldAlt,
    imgAlt: "Enhanced Privacy & Security",
    title: "Enhanced Privacy & Security",
    description: "Control who interacts with your content through built-in privacy settings"
  },
  {
    icon: FaMagic,
    imgAlt: "Creative Video Effects",
    title: "Creative Video Effects",
    description: "Apply filters, stickers, and effects to enhance and beautify your video content."
  },
  {
    icon: FaShareSquare,
    imgAlt: "Quick Sharing Features",
    title: "Quick Sharing Features",
    description: "Share videos instantly across platforms to reach a larger audience."
  },
  {
    icon: FaChartLine,
    imgAlt: "Detailed Analytics for Creators",
    title: "Detailed Analytics for Creators",
    description: "Analyze views, likes, and shares to understand your audience better."
  },

];


const ServiceSection = () => {
  return (
    <div className="section harsafe-servicess-section section-padding">
      <div className="container">
        <div className="services-wrap">
          <div className="section-title text-center">
            <h3 className="sub-title">Services</h3>
            <h2 className="title">Affordable Services for all</h2>
          </div>
          <div className="service-content-wrap">
            <div className="row right_choice_inner best_choice_inner mt-3">
              {services.map((service, index) => (
                <div key={index} className="col-lg-4 col-sm-6">
                  <div className="counter-item choice-item grayscale_img">
                    <div className="modalBoximg">
                    <service.icon className="service-icon" />
                      {/* <img src={service.imgSrc} alt={service.imgAlt} /> */}
                    </div>
                    <h4>{service.title}</h4>
                    <p>{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceSection;
